import { IApiQueryOptions } from 'api/ApiClient';

export enum Payments {
  GET_SITE_PAYMENTS_REQUEST = '@payment/GET_SITE_PAYMENTS_REQUEST',
  GET_SITE_PAYMENTS_SUCCESS = '@payment/GET_SITE_PAYMENTS_SUCCESS',
  GET_SITE_PAYMENTS_FAIL = '@payment/GET_SITE_PAYMENTS_FAIL',
}

export interface IGetSitePaymentsPayload {
  siteId: string;
  options?: IApiQueryOptions;
}
